import { ROLES } from "helpers/permissions";
import type { SystemUser } from "services/rolesPermissions";

export function roleTypesFromUser(user: SystemUser): string[] {
  return user.users_roles?.map((ur) => ur.role.type) ?? [];
}

export function userHasPanelAccess(types: string[]): boolean {
  if (types.includes(ROLES.ROLE_ADMIN) || types.includes(ROLES.ROLE_MASTER)) {
    return true;
  }
  const panelRoles = new Set<string>([
    ROLES.ROLE_USER,
    ROLES.ROLE_USER_FIN,
    ROLES.ROLE_USER_GER,
    ROLES.ROLE_USER_CRO,
    ROLES.ROLE_USER_ORG,
    ROLES.ROLE_ORGANIZADOR,
  ]);
  return types.some((t) => panelRoles.has(t));
}

export function roleChipSx(type: string) {
  if (type === ROLES.ROLE_ADMIN || type === ROLES.ROLE_MASTER) {
    return { bg: "rgba(249, 96, 48, 0.12)", fg: "#c2410c" };
  }
  if (type === ROLES.ROLE_ATLETA) {
    return { bg: "grey.200", fg: "text.secondary" };
  }
  return { bg: "rgba(59, 130, 246, 0.12)", fg: "#1d4ed8" };
}

export function computePageStats(users: SystemUser[], rowCount: number, isSearchMode: boolean) {
  const comPainel = users.filter((u) => userHasPanelAccess(roleTypesFromUser(u))).length;
  return {
    total: rowCount,
    pagina: users.length,
    comPainel,
    isSearchMode,
  };
}
